module.exports = __webpack_public_path__ + "img/Alert Icon - charcoal.68fd4ce6.svg";